
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cpap",
      function () {
        return require("private-next-pages/cpap/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cpap"])
      });
    }
  